'use strict'

import Vue from 'vue'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import MixinPlugin from '@/plugin/mixin'
import store from './store'
import i18n from './i18n'
import baidumap from 'vue-baidu-map'
import VideoPlayer from 'vue-video-player'
import '@/utils/filters'
import vRegion from 'v-region'
import mixins from '@/mixins'
import Print from 'vue-print-nb'


require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.use(ElementUI)
Vue.use(MixinPlugin)
Vue.use(vRegion)
Vue.mixin(mixins)
Vue.use(Print);

Vue.use(
    baidumap,{
        ak:'4X0NEpQnxqyh3Gn8cw0GzhLKoekBtHl9'
    }

)

import '@/assets/element.css'    //element定制主题样式

Vue.config.productionTip = false

Vue.prototype.$bus = new Vue();

Vue.prototype.$addStorageEvent = function (type, key, data) {
// 创建一个StorageEvent事件
var newStorageEvent = document.createEvent('StorageEvent');
// localStorage
if (type === 1) {
  const storage = {
    setItem: function (k, val) {
      localStorage.setItem(k, val);
      // 初始化创建的事件
      newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
      // 派发对象
      window.dispatchEvent(newStorageEvent);
    }
  }
  return storage.setItem(key, data);
} else {
   // sessionStorage
  const storage = {
    setItem: function (k, val) {
      sessionStorage.setItem(k, val);
      // 初始化创建的事件
      newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
      // 派发对象
      window.dispatchEvent(newStorageEvent);
    }
  }
  return storage.setItem(key, data);
}
}

// eslint-disable-next-line
router.beforeEach((to, from, next) => {
  store.commit('UPDATE_ISLOADING', true)
  if (to.path !== '/' && to.path !== '/login'&& to.path !== '/login2') {
    let userToken = store.getters.GetUserToken
    if (!userToken) {
      store.commit('UPDATE_REDIRECT_URL', to.fullPath)
      next({ path: '/login' })
    }
  }
  next()
})

// eslint-disable-next-line
router.afterEach((to, from) => {
  store.commit('UPDATE_CURRENT_PATH', to.path.toLowerCase())
  if (document && to.meta.title) {
    document.title = to.meta.title
  }
  store.commit('UPDATE_ISLOADING', false)
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
